module.exports = __webpack_public_path__ + "static/family-32c4e07f50c281428e785eb4b68241d1.png";